<p class="payment-method-suggestion">
  💡 Nous vous recommandons d'enregistrer une <b>carte bancaire</b> plutôt qu'un prélèvement SEPA :
  le paiement par carte est plus fiable et évite certains blocages ou retards au cours du processus de paiement.
</p>

<div [id]="idElement"></div>

<div class="after-element">
  <div>
    <ng-content></ng-content>
  </div>
  <button color="accent" (click)="save()" [disabled]="!ready" mat-raised-button>{{'register.stepper.save' | translate}}</button>
</div>
